<template lang="pug">
  section(id="try")
      .goscontainer.text-center.mt-8(v-if="$route.name!='Box'")
         v-container
           .heading Попробуйте сервис самостоятельно
           v-row
               v-col.mt-4.mx-auto(cols=12 md=6)
                v-form(ref="tryDemoForm" v-model="valid")
                   div(v-if="showForm")
                     v-text-field(v-model="form.fio"
                       placeholder="Ваше Ф.И.О."
                       outlined rounded flat solo light :rules="[rules.required]")
                     v-text-field(v-model="form.city"
                       placeholder="Ваш город"
                       outlined rounded flat solo light :rules="[rules.required]")
                     v-text-field(v-model="form.email"
                       placeholder="Ваш e-mail"
                       outlined rounded flat solo light :rules="[rules.email]")
                     v-text-field(v-model="form.phone"
                       placeholder="Контактный телефон"
                       outlined rounded flat solo light :rules="[rules.required]")

                     v-select(v-model="form.role"
                       :items="itemsRole"
                       menu-props="light"
                       label="К какой категории участников судебного процесса относитесь"
                       outlined rounded flat solo light :rules="[rules.requiredcombo]")

                     v-select(v-model="form.src"
                       :items="itemsSrc"
                       menu-props="light"
                       label="Откуда Вы узнали о нашем сервисе"
                       outlined rounded flat solo light :rules="[rules.requiredcombo]")


                   v-btn(rounded color="#ED0E51" dark x-large @click="sendMail" :disabled="!valid") ПОЛУЧИТЬ ДЕМО-ДОСТУП

      .goscontainer.text-center.text-md-left(v-else)
         v-container.min
           v-row.mx-auto
             v-col.mt-4(cols=12 md=6)
                .heading-box Сервис 
                   br 
                   span {{serv}}
                .thx(v-if="showForm") Спасибо за Ваш выбор продукта!
                   br
                   | Наш менеджер расскажет вам о нем более подробно!
             v-col.mt-4(cols=12 md=6)
                v-form(ref="tryDemoForm" v-model="valid")
                   div(v-if="showForm")
                     v-text-field(v-model="form.fio"
                       placeholder="Ваше Ф.И.О."
                       outlined rounded flat solo light :rules="[rules.required]")
                     v-text-field(v-model="form.city"
                       placeholder="Ваш город"
                       outlined rounded flat solo light :rules="[rules.required]")
                     v-text-field(v-model="form.email"
                       placeholder="Ваш e-mail"
                       outlined rounded flat solo light :rules="[rules.email]")
                     v-text-field(v-model="form.phone"
                       placeholder="Контактный телефон"
                       outlined rounded flat solo light :rules="[rules.required]")

                     v-select(v-model="form.role"
                       :items="itemsRole"
                       menu-props="light"
                       label="К какой категории участников судебного процесса относитесь"
                       outlined rounded flat solo light :rules="[rules.requiredcombo]")

                     v-select(v-model="form.src"
                       :items="itemsSrc"
                       menu-props="light"
                       label="Откуда Вы узнали о нашем сервисе"
                       outlined rounded flat solo light :rules="[rules.requiredcombo]")


                   v-btn(rounded color="#ED0E51" dark x-large @click="sendMail" :disabled="!valid") ПОЛУЧИТЬ ПРЕДЛОЖЕНИЕ

      v-snackbar(v-model="errorSnack" color="error" :timeout="6000" vertical top) {{errorSnackText}}
        v-btn(light text @click="errorSnack = false") Закрыть
      v-snackbar(v-model="successSnack" color="success" :timeout="10000" vertical top) {{successSnackText}}
        v-btn(light text @click="successSnack = false") Закрыть

</template>

<script>
let serv = {
  platform: 'ПЛАТФОРМА СУДЕБНЫЙ ПОРТАЛ',
  usz: 'Удаленное судебное заседание',
  zsd: 'Заказ судебных документов',
  za: 'Заявки адвоката',
  fsin: 'ФСИН',
  home: ''
}

import { courtService } from '@/_services'
import { $_validate_rules } from '@/common/ValidateRules'
  export default {
    mixins: [$_validate_rules],
    name: 'SectionTry',
    props: {
      alias: null
    },
    data () {
      const defaultForm = Object.freeze({
        fio: '',
        city: '',
        email: '',
        phone: '',
        role: '',
        src: '',
        serv: '',
        site: 'sudportal',
      })
    
      return {
        form: Object.assign({}, defaultForm),
        showForm: false,
        valid: false,
        errorSnackText: "",
        successSnackText: "",
        errorSnack: false,
        successSnack: false
      }
    },
    computed: {
      itemsRole () {
        return [
          { text: 'Судья/Помощник судьи'},
          { text: 'Консультант суда/Работник суда'},
          { text: 'Адвокат'},
          { text: 'Эксперт/Переводчик'},
          { text: 'Госслужащий'},
          { text: 'Журналист/пресс-секретарь'},
          { text: 'Участник по делу'},
        ]
      },
      itemsSrc () {
        return [
          { text: 'Через поисковый сервис' },
          { text: 'Информация на сайте суда' },
          { text: 'Видео-трансляции на стриминговых площадках' },
          { text: 'СМИ' },
          { text: 'Отзывы/рекомендации других людей' },
        ]
      },
      serv () {
        return serv[this.alias]
      }
    },
    methods: {
      showErrorSnack(text) {
        this.errorSnackText = text
        this.errorSnack = true
      },
      
      showSuccessSnack(text) {
        this.successSnackText = text
        this.successSnack = true
      },
      sendMail () {
        if (this.showForm && this.$refs.tryDemoForm.validate()) {
            this.form.serv = serv[this.alias]
            courtService.tryDemo(this.form).then(data => {
              if(data.status=="OK")  this.showSuccessSnack("Ваша заявка принята. В ближайшее время с вами свяжется наш сотрудник. На указанный е-mail вы также получите регистрационные данные для входа в тестовый кабинет сервиса. По всем вопросам обращаться по адресу hello@sudportal.ru");
              else this.showErrorSnack("Ошибка отправки запроса."); 
            })
        }
        this.showForm = true
      }
    }
  }
</script>

<style lang="sass" scoped>
  #try
    background-color: #0E9DBC
    padding: 30px 16px 30px 16px
    font-weight: 300
    .heading 
        font-family: $slab
        font-size: 36px
        color:#FFFFFF
    .heading-box
        font-size: 14px
        line-height: 24px
        text-transform: uppercase
        color: #FFFFFF
        span
          font-weight: bold
          font-size: 24px
    .min 
        max-width: 915px
    .thx
        margin-top: 32px
        font-size: 18px
        line-height: 24px
</style>
